import React from 'react';
import { Draggable } from 'react-smooth-dnd';
import ItemImage from '../ItemImage/ItemImage';
import { getOverlayForItem } from '../helpers/isDraggingHelpers';

const renderDraggableItem = (props, item, i) => {
    return (
        <Draggable key={i}>
            <li className={setClass(props.containerClass, item, props.showFixedElements, props.isMobileOn, props.isPreviewOn)}>
                <ItemImage isPreviewOn={props.isPreviewOn} item={item} isMobileOn={props.isMobileOn} />
                {getOverlayForItem(props, i, item)}
            </li>
        </Draggable>
    );
};

const renderStaticItem = (props, item, i) => {
    const shouldHide = item[`hideOn${props.bodyListName}`];
    
    if (shouldHide) {
        return null;
    }
    
    return (
        <li key={i} className={setClass(props.containerClass, item, props.showFixedElements, props.isMobileOn, props.isPreviewOn)}>
            <ItemImage isPreviewOn={props.isPreviewOn} item={item} isMobileOn={props.isMobileOn} />
        </li>
    );
};

const ItemToDraggableMapper = (props) => (
    <React.Fragment>
        {props.items.map((item, i) => {
            const isDraggable = !props.isPreviewOn && !item.isNoneDrag;
            
            if (isDraggable) {
                return renderDraggableItem(props, item, i);
            }
            
            return renderStaticItem(props, item, i);
        })}
    </React.Fragment>
);

function findObiectWidget(mainBodyItems) {
    if (mainBodyItems !== null) {
        for (const item of mainBodyItems) {
            if (item.id === "widget-1" || item.id === "widget-2") {
                return JSON.parse(item.config).widgetPosition;
            }
        }
    }
    return null;
}

function setPopupClass(containerClass, isPreviewOn, isMobileOn) {
    let className = containerClass + "__item";
    className += " " + containerClass + "__popup";

    if (isPreviewOn && !isMobileOn) {
        return className + ' popupPreview';
    } 
    if (isMobileOn) {
        className += " " + containerClass + "__hidden";
    }

    return className;
}

function setWidgetClass(containerClass, widgetPosition, settings, isPreviewOn, isMobileOn) {
    let className = containerClass + "__item";
    if(widgetPosition !== null || settings !== null){
        if(widgetPosition==="rightTop"  ){
            className = "draggable-list__item " + containerClass + "__popup__widget1__rightTop";
        }
        else if (widgetPosition==="leftTop" ) {
            className = "draggable-list__item " + containerClass + "__popup__widget1__leftTop";
        }
        else if (widgetPosition==="leftBottom"  ) {
            className = "draggable-list__item " + containerClass + "__popup__widget1__leftBottom";
        }
        else{
            className = "draggable-list__item " + containerClass + "__popup__widget1__rightBottom";
        
        }
    } else {
        className = "draggable-list__item " + containerClass + "__popup__widget1__rightBottom";
    }

    if (isPreviewOn && !isMobileOn) {
        return className + ' popupPreview';
    } 
    if (isMobileOn) {
        className += ' hidden';
    }

    return className;
}

function setClass(containerClass, item, showFixedElements, isMobileOn, isPreviewOn) {
    let className = '';
    if (item.id === 'popupBanner-1' || item.id === 'newsletterPopup-1') {
        className = setPopupClass(containerClass, isPreviewOn, isMobileOn);
    } else if (item.id === 'widget-1' || item.id === 'widget-2') {
        const settings = JSON.parse(localStorage.getItem('onlineCreatorB2B-settings'));
        let widgetPosition = JSON.parse(localStorage.getItem('onlineCreatorB2B-widget'));
        const mainBodyItems = JSON.parse(localStorage.getItem('onlineCreatorB2B-mainBody'));
        
        widgetPosition = findObiectWidget(mainBodyItems);
        className = setWidgetClass(containerClass, widgetPosition, settings, isPreviewOn, isMobileOn);
    } else {
        className = containerClass + "__item";
    }
    
    if (item.fixedView && !showFixedElements && containerClass !== 'draggable-list') {
        className = containerClass + "__hidden";
    }

    return(className);
}



export default ItemToDraggableMapper;